export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6389.d4ccb2d6.jpg";